import React from 'react'

const ChartsHeader = () => {
  return (
    <div>
      
    </div>
  )
}

export default ChartsHeader
